import { query, mutation } from '@/dex-shared/helpers/graphql';

export default {
  state: {
    board_sections: [],
    board_section: null,
  },
  getters: {
    currentBoardSection: (state: any) => {
      return state.board_section;
    },
  },
  mutations: {
    SET_CURRENT_BOARD_SECTION(state: any, board_section: any) {
      state.board_section = board_section;
    },
    SET_BOARD_SECTIONS(state: any, board_sections: any) {
      state.board_sections = board_sections;
    },
    SET_EMPTY_BOARD_SECTION(state: any) {
      let board_section = {
        id: null,
        title: null,
        description: null,
        descomplicaSubjectSlug: null,
        boardByBoardId: {
          id: null,
          title: null,
        },
      };
      state.board_section = board_section;
    },
  },
  actions: {
    async PULL_BOARD_SECTION({ commit }: any, boardSectionId: number) {
      let response = await query(
        `query getBoardSectionByIdDexAdmin($boardSectionId: Int!) {
            boardSectionById(id: $boardSectionId) {
              id
              title
              description
              descomplicaSubjectSlug
              boardByBoardId {
                id
                title
                descomplicaDisciplineSlug
              }
              boardSubsectionsByBoardSectionId {
                nodes {
                  id
                  title
                  description
                  descomplicaTopicSlug
                }
              }
              materialsByBoardSectionsId {
                nodes {
                  id
                  listByListId {
                    id
                    name
                  }
                  examGroupByExamGroupId {
                    id
                    name
                  }
                }
              }
            }
          }`,
        {
          boardSectionId: boardSectionId,
        },
      );
      let boardSection = response.data.boardSectionById;
      if (boardSection) {
        commit('SET_CURRENT_BOARD_SECTION', boardSection);
      }
    },
    async PULL_BOARD_SECTIONS({ commit }: any) {
      let response = await query(`query getAllBoardSectionsDexAdmin{
            allBoardSections(first: 200, orderBy: ID_DESC) {
              nodes {
                id
                title
                description
                descomplicaSubjectSlug
                boardByBoardId {
                  id
                  title
                }
              }
            }
          }`);
      let boardSectionNodes = response.data.allBoardSections;
      if (boardSectionNodes) {
        commit('SET_BOARD_SECTIONS', boardSectionNodes.nodes);
      }
    },
    async PUSH_BOARD_SECTION({ commit }: any, boardSection: any) {
      if (boardSection.id) {
        let response = await mutation(
          `mutation dexAdminUpdateBoardSectionById($id: Int!, $title: String, $description: String, $boardId: Int, $descomplicaSubjectSlug: String) {
          updateBoardSectionById(
            input: {
              id: $id
              boardSectionPatch: {
                title: $title
                description: $description
                boardId: $boardId
                descomplicaSubjectSlug: $descomplicaSubjectSlug
              }
          }) {
            boardSection {
              id
              title
              description
              descomplicaSubjectSlug
              boardByBoardId {
                id
                title
                descomplicaDisciplineSlug
              }
              boardSubsectionsByBoardSectionId {
                nodes {
                  id
                  title
                  description
                  descomplicaTopicSlug
                }
              }
            }
          }
        }`,
          {
            id: boardSection.id,
            title: boardSection.title,
            description: boardSection.description,
            boardId: boardSection.boardByBoardId.id,
            descomplicaSubjectSlug: boardSection.descomplicaSubjectSlug,
          },
        );
        commit(
          'SET_CURRENT_BOARD_SECTION',
          response.data.updateBoardSectionById.boardSection,
        );
      } else {
        // TODO: find out why RLS complains about insert
        let response = await mutation(
          `mutation dexAdminCreateBoardSection($title: String, $description: String, $boardId: Int!, $descomplicaSubjectSlug: String) {
          createBoardSection(
            input: {
              boardSection: {
                title: $title
                description: $description
                boardId: $boardId
                descomplicaSubjectSlug: $descomplicaSubjectSlug
              }
          }) {
            boardSection {
              id
              title
              description
              descomplicaSubjectSlug
              boardByBoardId {
                id
                title
                descomplicaDisciplineSlug
              }
              boardSubsectionsByBoardSectionId {
                nodes {
                  id
                  title
                  description
                  descomplicaTopicSlug
                }
              }
            }
          }
        }`,
          {
            title: boardSection.title,
            description: boardSection.description,
            boardId: boardSection.boardByBoardId.id,
            descomplicaSubjectSlug: boardSection.descomplicaSubjectSlug,
          },
        );
        commit(
          'SET_CURRENT_BOARD_SECTION',
          response.data.createBoardSection.boardSection,
        );
      }
    },
  },
};
